import type { ComponentType } from "react";
import type { LocalizedPost } from "../../../types";
import * as uiProblem from "./ui-problem-ai-coding-agents";
import * as dashboards from "./why-llms-cannot-design-dashboards";
import * as finishedWork from "./illusion-of-finished-work";
import * as vibecodingAddiction from "./vibecoding-addiction";
import * as fakeBenchmarks from "./the-benchmarks-are-fake";
import * as agentLoops from "./designing-an-agent-loop-for-coding";
import * as agentObservability from "./observing-six-coding-agent-clis";

/** Shape every post module exposes: meta strings + a default-exported body. */
interface PostModule {
  title: string;
  excerpt: string;
  heroAlt?: string;
  readingTime?: string;
  default: ComponentType;
}

const toPost = (m: PostModule): LocalizedPost => ({
  title: m.title,
  excerpt: m.excerpt,
  heroAlt: m.heroAlt,
  readingTime: m.readingTime,
  Content: m.default,
});

export const posts: Record<string, LocalizedPost> = {
  "why-llms-cannot-design-dashboards": toPost(dashboards),
  "observing-six-coding-agent-clis": toPost(agentObservability),
  "designing-an-agent-loop-for-coding": toPost(agentLoops),
  "the-benchmarks-are-fake": toPost(fakeBenchmarks),
  "vibecoding-addiction": toPost(vibecodingAddiction),
  "illusion-of-finished-work": toPost(finishedWork),
  "ui-problem-ai-coding-agents": toPost(uiProblem),
};
